<template>
  <v-container fluid class="pa-0">
    <v-card elevation="0">
      <v-card-title class="d-flex justify-space-between">
        <div>Customer List</div>
        <div>
          <v-btn
            depressed
            rounded
            color="primary"
            @click="customerDialog = !customerDialog"
          >
            <i class="fas fa-plus mr-1"></i>Add New Customer
          </v-btn>
        </div>
      </v-card-title>
      <v-card-text class="pa-0" style="border-top: 1px solid lightgray">
        <div style="overflow-x: auto">
          <v-data-table
        mobile-breakpoint="0"
        :headers="headers"
        :items="filteredCustomers"
        :items-per-page="15"
        :options.sync="options"
        class="elevation-0"
      >
        <template v-slot:header>
          <tr>
            <th v-for="(header, idx) in headers" :key="`header-${idx}`">
              <v-text-field
                v-if="header.value != 'action'"
                dense
                class="ma-2"
                rounded
                v-model="filter[header.value]"
                placeholder="filter"
                solo-inverted
                hide-details
                flat
              ></v-text-field>
            </th>
          </tr>
        </template>
        <template v-slot:item="{ item }">
          <tr>
            <td>
              <a
                @click="
                  $router
                    .push({
                      name: 'CustomerUpdate',
                      params: { id: item.id },
                    })
                    .catch(() => {})
                "
                >{{ item.id }}</a
              >
            </td>
            <td>{{ item.name }}</td>
            <td>{{ item.address1 }}</td>
            <td>{{ item.address2 }}</td>
            <td>{{ item.phone }}</td>
            <td>{{ getCustomerName(item.parentCustomerId) }}</td>
            <td>
              <v-btn
                color="error"
                depressed
                icon
                @click="
                  deleteDialog = true;
                  toDeleteCustomer = item.id;
                "
                :loading="toDeleteCustomer == item.id"
                >x</v-btn
              >
            </td>
          </tr>
        </template></v-data-table
      >
        </div>
      </v-card-text>
    </v-card>
    <customer-dialog v-model="customerDialog"></customer-dialog>
    <general-dialog
      v-model="deleteDialog"
      :dialog="deleteDialog"
      :options="deleteOptions"
      @handle-event="deleteCustomer"
    ></general-dialog>
  </v-container>
</template>
<script>
import eventBus from "@/js/event-bus.js";
import backendService from "@/services/backend-service";
import GeneralDialog from "@/components/GeneralDialog.vue";
import CustomerDialog from "@/components/CustomerDialog.vue";
import generalMixin from "@/js/general-mixin";
export default {
  name: "CustomerList",
  components: {
    "general-dialog": GeneralDialog,
    "customer-dialog": CustomerDialog,
  },
  mixins: [generalMixin],
  data() {
    return {
      customerDialog: false,
      headers: [
        {
          text: "Id",
          align: "start",
          value: "id",
          width: 100,
        },
        { text: "Name", value: "name", width: 200 },
        { text: "Address 1", value: "address1", width: 300 },
        { text: "Address 2", value: "address2", width: 300 },
        { text: "Phone", value: "phone", width: 200 },
        { text: "Parent", value: "parentCustomerId", width: 200 },
        { text: "Action", value: "action", width: 100 },
      ],
      toDeleteCustomer: -1,
      deleteDialog: false,
      deleteOptions: {
        btnText: "Yes",
        message: "This action is not revertable!",
        title: "Are you sure you want to delete this customer?",
      },
    };
  },
  mounted: function () {
    return eventBus.$on("generateCsv", this.generateCsv);
  },
  computed: {
    filteredCustomers() {
      let customers = this.customers;
      for (let key in this.filter) {
        let searchStr = this.filter[key].trim().toLowerCase();
        let header = this.headers.find((header) => header.value == key);
        if (searchStr && searchStr.length) {
          customers = customers.filter((e) => {
            let str = this.getDataText(header, e);
            return str
              .toString()
              .trim()
              .toLowerCase()
              .includes(this.filter[key].toLowerCase());
          });
        }
      }
      return customers;
    },
    customers: {
      get() {
        return this.$store.getters["customers"];
      },
      set(val) {
        this.$store.commit("customers", val);
      },
    },
    options: {
      get() {
        return this.$store.getters["interactStore/customerOptions"];
      },
      set(val) {
        this.$store.commit("interactStore/setCustomerOptions", val);
      },
    },
    filter: {
      get() {
        return this.$store.getters["interactStore/customerFilter"];
      },
      set(val) {
        this.$store.commit("interactStore/setCustomerFilter", val);
      },
    },
  },
  methods: {
    deleteCustomer() {
      backendService.deleteCustomerById(this.toDeleteCustomer).then(() => {
        this.timer(1000)
          .then(() => {
            let newCustomers = this.customers.filter(
              (e) => e.id != this.toDeleteCustomer
            );
            this.$store.commit("setCustomers", newCustomers);
            this.toDeleteCustomer = -1;
            this.successSnackbar("Successfully updated the invoice");
          })
          .catch(() => {
            this.toDeleteCustomer = -1;
            this.errorSnackbar("Ops! Something is not right");
          });
      });
    },
    generateCsv() {
      let headerStr = "Id;Name;Address 1;Address 2;Phone";
      let csvContent = "";
      csvContent += headerStr + "\r\n";

      for (let i = 0; i < this.filteredCustomers.length; i++) {
        const customer = this.filteredCustomers[i];
        let rowStr = `${customer.id};${this.getCustomerName(
          customer.id,
          false
        )};"${customer.address1.trim()}";"${
          customer.address2 != null ? customer.address2.trim() : ""
        }";${customer.phone.trim()}`;
        csvContent += rowStr + "\r\n";
      }
      let blob = new Blob([csvContent], { type: "text/plain" });
      let url = URL.createObjectURL(blob);
      let link = document.createElement("a");
      link.setAttribute("href", url);
      link.setAttribute("download", `customer-list.csv`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    getDataText(header, customer) {
      if (header.value == "id") {
        return customer.id.toString();
      } else if (header.value == "name") {
        return customer.name;
      } else if (header.value == "address1") {
        return customer.address1;
      } else if (header.value == "address2" && customer.address2 != null) {
        return customer.address2;
      } else if (header.value == "phone") {
        return customer.phone;
      } else {
        return "";
      }
    },
  },
  destroyed: function () {
    eventBus.$off("generateCsv");
  },
};
</script>
